﻿import './groupedSelect';
//import 'jquery-ui';
import 'jquery-ui/ui/widgets/autocomplete';
import('Vendors/selectToAutocomplete/jquery.select-to-autocomplete.1.0.9');
import 'Vendors/jquery.sticky'
import { ScrollToSearchBarForDropDown } from './groupedSelect-functions.js';
import { type } from 'jquery';

//import ko from 'knockout';
/* Custom Knockout bindings: groupedSelect and autoComplete
*  required: jQuery UI Autocomplete; groupedSelect.js
*
*  Remarks: ko.bindingHandlers.autoComplete is part of 'groupedSelect' binding.
*  'autoComplete' binding should be refactored and moved to separate knockout.autoComplete.js 
*  if start to use this binding without 'groupedSelect' binding.
*/
ko.bindingHandlers.groupedSelect = {
    // ***
    // Autocomplete is based on http://jsfiddle.net/HfNk9/3/
    // ***
    findSelectedItem: function (dataSource, binding, selectedValue) {
        var unwrap = ko.utils.unwrapObservable;
        //Go through the source and find the id, and use its label to set the autocomplete
        var source = unwrap(dataSource);
        var valueProp = unwrap(binding.optionsValue);

        var selectedItem = ko.utils.arrayFirst(source, function (item) {
            var value = unwrap(item[valueProp]);
            if (!value)
                return false;
            if (value === '' || value === 0)
                return false;
            if (value === selectedValue)
                return true;
        }, this);

        return selectedItem;
    },
    buildDataSource: function (dataSource, labelProp, valueProp) {
        var unwrap = ko.utils.unwrapObservable;
        //var source = unwrap(dataSource);
        var source = ko.utils.arrayFilter(unwrap(dataSource), function (item) {
            var value = unwrap(item[valueProp]);
            if (!value)
                return false;
            if (value === '' || value === 0)
                return false;
            return true;
        });
        var mapped = ko.utils.arrayMap(source, function (item) {
            var result = {};
            result.label = labelProp ? unwrap(item[labelProp]) : unwrap(item).toString();  //show in pop-up choices
            result.value = valueProp ? unwrap(item[valueProp]) : unwrap(item).toString();  //value 
            return result;
        });
        return mapped;
    },
    findAutocompleteItem: function (dataSource, binding, autocompleteValue) {
        var unwrap = ko.utils.unwrapObservable;
        //Go through the source and find the id, and use its label to set the autocomplete
        var source = unwrap(dataSource);
        var textProp = unwrap(binding.optionsText);
        var selectedItem = ko.utils.arrayFirst(source, function (item) {
            var text = unwrap(item[textProp]);
            if (!text)
                return false;
            if (text === '')
                return false;
            if (text === autocompleteValue)
                return true;
        }, this);

        return selectedItem;
    },
    // init current binding after defined bindings in array
    // like there is definition of ko.bindingHandlers['value']
    after: ['options', 'foreach'], 
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        if ($(element).is('select')) {
            var result;
            var options = allBindingsAccessor().groupedSelectOptions || {};
            var dropdownContainer = options.dropdownContainer || '';
            let subscriptions = [];

            // clean up memory when knockout removes binding
            ko.utils.domNodeDisposal.addDisposeCallback(element, function (disposingElement) {
                //$(disposingElement).off("change");
                //var $input = $(element).next('.grouped-select').find('.current');
                //if ($input.length > 0) {
                //    $input.off("click");
                //    $input.autocomplete('destroy');
                //}
                $(element).groupedSelect('destroy');

                for (var i = 0; i < subscriptions.length; i++) {
                    let subscription = subscriptions[i];
                    if (subscription) {
                        subscription.dispose();
                    }
                }
            });

            $(element).addClass('groupedSelect').groupedSelect(options);

            //$(element).on("change", function () {
            //    $(element).groupedSelect('refresh');
            //});

            if (ko.isObservable(valueAccessor())) {
                //result = ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor, viewModel, context);
                result = ko.bindingHandlers.value.init.apply(this, arguments);
            }

            var $input = $(element).next('.grouped-select').find('.grouped-input');
            if (options.autoComplete && $input.length > 0) {
                //$input.on("click", function (event) {
                //    event.stopPropagation();
                //    $dropdown = $(element).next('.grouped-select');
                //    if ($dropdown.length > 0) {
                //        var qtip = $dropdown.qtip('api');
                //        if (qtip)
                //            qtip.hide();
                //        $dropdown.removeClass('open');
                //    }
                //});

                var unwrap = ko.utils.unwrapObservable;
                //var dataSource = valueAccessor();
                var binding = allBindingsAccessor();
                var valueProp = unwrap(binding.optionsValue);
                var labelProp = unwrap(binding.optionsText) || valueProp;
                //var displayId = $(element).attr('id') + '-display';
                //var displayElement;
                var autoCompleteOptions = {};

                var dataSource = binding.options;
                var displayElement = $input;
                var displayId = $input.attr('id');
                var modelValue = valueAccessor();

                if (binding.autoCompleteOptions) {
                    autoCompleteOptions = $.extend(autoCompleteOptions, binding.autoCompleteOptions);
                }

                //Create a new input to be the autocomplete so that the label shows
                // also hide the original control since it will be used for the value binding
                //$(element).hide();
                //$(element).after('<input type="text" id="' + displayId + '" />')
                //displayElement = $('#' + displayId);

                //handle value changing
                //var modelValue = binding.value;
                var modelValue = valueAccessor();
                if (modelValue) {
                    var writeValueToModel = function (valueToWrite) {
                        if (ko.isWriteableObservable(modelValue)) {
                            //Since this is an observable, the update part will fire and select the 
                            //  appropriate display values in the controls
                            modelValue(valueToWrite);
                        } else {  //write to non-observable
                            if (binding['_ko_property_writers'] && binding['_ko_property_writers']['value']) {
                                binding['_ko_property_writers']['value'](valueToWrite);
                                //Because this is not an observable, we have to manually change the controls values
                                // since update will not do it for us (it will not fire since it is not observable)
                                displayElement.val(labelToWrite);
                                $(element).val(valueToWrite);
                            }
                        }
                    }

                    var handleValueChange = function (event, ui) {
                        var labelToWrite = ui.item ? ui.item.label : null
                        var valueToWrite = ui.item ? ui.item.value : null;
                        if (labelToWrite && valueToWrite) {
                            //The Label and Value should not be null, if it is
                            // then they did not make a selection so do not update the 
                            // ko model
                            writeValueToModel(valueToWrite);
                        }
                            //else {
                            //    //They did not make a valid selection so change the autoComplete box back to the previous selection
                            //    var currentModelValue = unwrap(modelValue);
                            //    //If the currentModelValue exists and is not nothing, then find out the display
                            //    // otherwise just blank it out since it is an invalid value
                            //    if (!currentModelValue)
                            //        displayElement.val('');
                            //    else {
                            //        //Go through the source and find the id, and use its label to set the autocomplete
                            //        var selectedItem = ko.bindingHandlers.groupedSelect.findSelectedItem(dataSource, binding, currentModelValue);
                            //
                            //        //If we found the item then update the display
                            //        if (selectedItem) {
                            //            var displayText = labelProp ? unwrap(selectedItem[labelProp]) : unwrap(selectedItem).toString();
                            //            displayElement.val(displayText);
                            //        }
                            //        //if we did not find the item, then just blank it out, because it is an invalid value
                            //        else {
                            //            displayElement.val('');
                            //        }
                            //    }
                            //}
                        else {
                            //They did not make a valid selection so make sure that it is a valid value or clear out the model value
                            var autocompleteValue = $(event.target).val();
                            var matchingItem = ko.bindingHandlers.groupedSelect.findAutocompleteItem(dataSource, binding, autocompleteValue);

                            //if (matchingItem) {
                            //    var currentModelValue = unwrap(modelValue);
                            //    var currentValue = unwrap(currentModelValue[valueProp]);
                            //    var matchingValue = unwrap(matchingItem[valueProp]);
                            //    if (currentValue !== matchingValue)
                            //        matchingItem = null;
                            //}

                            if (matchingItem) {
                                valueToWrite = unwrap(matchingItem[valueProp]);
                                writeValueToModel(valueToWrite);
                                var displayText = labelProp ? unwrap(matchingItem[labelProp]) : unwrap(matchingItem).toString();
                                displayElement.val(displayText);
                            } else {
                                writeValueToModel(null);
                            }

                        }

                        return false;
                    };

                    var handleFocus = function (event, ui) {
                        $(displayElement).val(ui.item.label);
                        return false;
                    };

                    autoCompleteOptions.change = handleValueChange;
                    autoCompleteOptions.select = handleValueChange;
                    autoCompleteOptions.focus = handleFocus;
                    //autoCompleteOptions.close = handleValueChange;
                    autoCompleteOptions.renderMenu = function (ul, items) {
                        $(ul).addClass('grouped-select-menu').removeClass('ui-corner-all');
                        if ($(displayElement).hasClass('is-sticky-parent')) {
                            $(ul).addClass('is-sticky-parent');
                        }
                    };
                }

                //handle the choices being updated in a Dependant Observable (DO), so the update function doesn't 
                // have to do it each time the value is updated. Since we are passing the dataSource in DO, if it is
                // an observable, when you change the dataSource, the dependentObservable will be re-evaluated
                // and its subscribe event will fire allowing us to update the autocomplete datasource
                var mappedSource = ko.dependentObservable(function () {
                    return ko.bindingHandlers.groupedSelect.buildDataSource(dataSource, labelProp, valueProp);
                }, viewModel);
                //Subscribe to the knockout observable array to get new/remove items
                mappedSource.subscribe(function (newValue) {
                    displayElement.autocomplete("option", "source", newValue);
                });

                autoCompleteOptions.source = mappedSource();

                displayElement.autocomplete(autoCompleteOptions);
            }

            let binding_groupedSelectEnabled = allBindingsAccessor().groupedSelectEnabled || undefined;
            if (typeof binding_groupedSelectEnabled != "undefined") {
                let set_enable = function (newValue) {
                    if (newValue && newValue === true) {
                        $(element).groupedSelect('enable');
                    } else {
                        $(element).groupedSelect('disable');
                    }
                };

                set_enable(ko.unwrap(binding_groupedSelectEnabled));

                if (ko.isObservable(binding_groupedSelectEnabled)) {
                    let subscription = binding_groupedSelectEnabled.subscribe(set_enable);
                    subscriptions.push(subscription);
                }
            }

            return result;
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor, bindingContext) {
        var newValue = ko.unwrap(valueAccessor());
        if ($(element).is('select')) {
            var originalIndex = element.selectedIndex;
            var result = ko.bindingHandlers.value.update.apply(this, arguments);
            var options = allBindingsAccessor().groupedSelectOptions || {};

            if (originalIndex !== element.selectedIndex) {
                ko.utils.triggerEvent(element, "change");
            }
            $(element).groupedSelect('refresh');

            var $input = $(element).next('.grouped-select').find('.grouped-input');
            if (options.autoComplete && $input.length > 0) {
                //update value based on a model change
                var unwrap = ko.utils.unwrapObservable;
                //var dataSource = valueAccessor();
                var binding = allBindingsAccessor();
                var valueProp = unwrap(binding.optionsValue);
                var labelProp = unwrap(binding.optionsText) || valueProp;
                //var displayId = $(element).attr('id') + '-display';
                //var displayElement = $('#' + displayId);
                //var modelValue = binding.value;
                var dataSource = binding.options;
                var displayElement = $input;
                var displayId = $input.attr('id');
                var modelValue = valueAccessor();

                if (modelValue) {
                    var currentModelValue = unwrap(modelValue);
                    //Set the hidden box to be the same as the viewModels Bound property
                    $(element).val(currentModelValue);
                    //Go through the source and find the id, and use its label to set the autocomplete
                    var selectedItem = ko.bindingHandlers.groupedSelect.findSelectedItem(dataSource, binding, currentModelValue);
                    if (selectedItem) {
                        var displayText = labelProp ? unwrap(selectedItem[labelProp]) : unwrap(selectedItem).toString();
                        displayElement.val(displayText);
                    } else {
                        displayElement.val('');
                    }
                }
            }


            return result;
        }
    }
};


ko.bindingHandlers.autoComplete = {
    // ***
    // Autocomplete is based on http://jsfiddle.net/HfNk9/3/
    // ***
    findSelectedItem: function (dataSource, binding, selectedValue) {
        var unwrap = ko.utils.unwrapObservable;
        //Go through the source and find the id, and use its label to set the autocomplete
        var source = unwrap(dataSource);
        var valueProp = unwrap(binding.optionsValue);

        var selectedItem = ko.utils.arrayFirst(source, function (item) {
            var value = unwrap(item[valueProp]);
            if (!value)
                return false;
            if (value === '' || value === 0)
                return false;
            if (value === selectedValue)
                return true;
        }, this);

        return selectedItem;
    },
    buildDataSource: function (dataSource, labelProp, valueProp) {
        var unwrap = ko.utils.unwrapObservable;
        //var source = unwrap(dataSource);
        var source = ko.utils.arrayFilter(unwrap(dataSource), function (item) {
            var value = unwrap(item[valueProp]);
            if (!value)
                return false;
            if (value === '' || value === 0)
                return false;
            return true;
        });
        var mapped = ko.utils.arrayMap(source, function (item) {
            var result = {};
            result.label = labelProp ? unwrap(item[labelProp]) : unwrap(item).toString();  //show in pop-up choices
            result.value = valueProp ? unwrap(item[valueProp]) : unwrap(item).toString();  //value 
            return result;
        });
        return mapped;
    },
    findAutocompleteItem: function (dataSource, binding, autocompleteValue) {
        var unwrap = ko.utils.unwrapObservable;
        //Go through the source and find the id, and use its label to set the autocomplete
        var source = unwrap(dataSource);
        var textProp = unwrap(binding.optionsText);

        var selectedItem = ko.utils.arrayFirst(source, function (item) {
            var text = unwrap(item[textProp]);
            if (!text)
                return false;
            if (text === '')
                return false;
            if (text === autocompleteValue)
                return true;
        }, this);

        return selectedItem;
    },
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var unwrap = ko.utils.unwrapObservable;
        var dataSource = valueAccessor();
        var binding = allBindingsAccessor();
        var valueProp = unwrap(binding.optionsValue);
        var labelProp = unwrap(binding.optionsText) || valueProp;
        var displayId = $(element).attr('id') + '-display';
        var displayElement;
        var options = {};
        //var displayMenu = {};
        var menuOptions = null;

        if (binding.autoCompleteOptions) {
            options = $.extend(options, binding.autoCompleteOptions);
        }
        //if (binding.autoCompleteMenu) {
        //    displayMenu = $.extend(displayMenu, binding.autoCompleteMenu);
        //}

        if (binding.autoCompleteMenuOptions) {
            menuOptions = $.extend({}, menuOptions, binding.autoCompleteMenuOptions);
        }

        //Create a new input to be the autocomplete so that the label shows
        // also hide the original control since it will be used for the value binding
        $(element).hide();
        //$(element).after('<input type="text" id="' + displayId + '" />');
        //var displayElement = $('#' + displayId);
        var displayElement = $('<input/>').attr({ type: 'text', id: displayId, name: displayId });
        displayElement.addClass($(element).attr('class') || '');
        displayElement.attr('placeholder', $(element).attr('placeholder') || '');
        $(element).after(displayElement);

        var bindTo = unwrap(binding.autoCompleteSearchTerm) || "";
        if (bindTo != null && bindTo != "") {
            displayElement.attr('data-bind', "textInput: " + bindTo);
            ko.applyBindings(viewModel, displayElement[0]);
        }

        var autoCompleteQtip = unwrap(binding.autoCompleteQtip) || '';

        
        //handle value changing
        var handleValueChange = null;
        var handleValueChange_postprocessing = function () {
            if (autoCompleteQtip != '') {
                var $qtipContainer = $(element).parents(".qtip");
                if ($qtipContainer.length > 0) {
                    var qtipId = $qtipContainer.data('qtip-id');
                    var $qtip = null;
                    var g = $.grep($(autoCompleteQtip), function (item) {
                        var $item = $(item);
                        return $item.data('hasqtip') == qtipId;
                    });
                    if (g && g.length > 0) {
                        $qtip = $(g[0]);
                    }

                    if ($qtip && $qtip.length > 0) {
                        var qtip = $qtip.qtip('api');
                        if (qtip) {
                            qtip.hide();
                            ScrollToSearchBarForDropDown($qtip);
                        }
                    }
                }
            }

        };
        var modelValue = binding.value;
        if (modelValue) {
            var writeValueToModel = function (valueToWrite) {
                if (ko.isWriteableObservable(modelValue)) {
                    //Since this is an observable, the update part will fire and select the 
                    //  appropriate display values in the controls
                    modelValue(valueToWrite);
                } else {  //write to non-observable
                    if (binding['_ko_property_writers'] && binding['_ko_property_writers']['value']) {
                        binding['_ko_property_writers']['value'](valueToWrite);
                        //Because this is not an observable, we have to manually change the controls values
                        // since update will not do it for us (it will not fire since it is not observable)
                        displayElement.val(labelToWrite);
                        $(element).val(valueToWrite);
                    }
                }
            }

            handleValueChange = function (event, ui) {
                var labelToWrite = ui.item ? ui.item.label : null
                var valueToWrite = ui.item ? ui.item.value : null;
                if (labelToWrite && valueToWrite) {
                    //The Label and Value should not be null, if it is
                    // then they did not make a selection so do not update the 
                    // ko model
                    writeValueToModel(valueToWrite);

                    // save values to global variables for google analytics tracking in function trackSearchBtnClick
                    //searchbarLastDestinationClicked = labelToWrite;
                    //searchbarLastTypeClicked = "destination-autocomplete";
                    if (binding.autoCompleteValueChange) {
                        if (typeof binding.autoCompleteValueChange == "function") {
                            binding.autoCompleteValueChange(labelToWrite);
                        }
                    }

                }
                //else {
                //    //They did not make a valid selection so change the autoComplete box back to the previous selection
                //    var currentModelValue = unwrap(modelValue);
                //    //If the currentModelValue exists and is not nothing, then find out the display
                //    // otherwise just blank it out since it is an invalid value
                //    if (!currentModelValue)
                //        displayElement.val('');
                //    else {
                //        //Go through the source and find the id, and use its label to set the autocomplete
                //        var selectedItem = ko.bindingHandlers.autoComplete.findSelectedItem(dataSource, binding, currentModelValue);
                //
                //        //If we found the item then update the display
                //        if (selectedItem) {
                //            var displayText = labelProp ? unwrap(selectedItem[labelProp]) : unwrap(selectedItem).toString();
                //            displayElement.val(displayText);
                //        }
                //        //if we did not find the item, then just blank it out, because it is an invalid value
                //        else {
                //            displayElement.val('');
                //        }
                //    }
                //}
                else {
                    //They did not make a valid selection so make sure that it is a valid value or clear out the model value
                    var autocompleteValue = $(event.target).val();
                    var matchingItem = ko.bindingHandlers.autoComplete.findAutocompleteItem(dataSource, binding, autocompleteValue);

                    //if (matchingItem) {
                    //    var currentModelValue = unwrap(modelValue);
                    //    var currentValue = unwrap(currentModelValue[valueProp]);
                    //    var matchingValue = unwrap(matchingItem[valueProp]);
                    //    if (currentValue !== matchingValue)
                    //        matchingItem = null;
                    //}

                    if (matchingItem) {
                        valueToWrite = unwrap(matchingItem[valueProp]);
                        writeValueToModel(valueToWrite);
                        var displayText = labelProp ? unwrap(matchingItem[labelProp]) : unwrap(matchingItem).toString();
                        displayElement.val(displayText);
                    } else {
                        //writeValueToModel(null);
                    }

                }

                handleValueChange_postprocessing();
                return false;
            };
        }

        var modelSelectedItem = binding.autoCompleteSelectedItem
        if (modelSelectedItem) {
            var writeValueToModel = function (valueToWrite) {
                if (ko.isWriteableObservable(modelSelectedItem)) {
                    //Since this is an observable, the update part will fire and select the 
                    //  appropriate display values in the controls
                    modelSelectedItem(valueToWrite);
                } else {  //write to non-observable
                    // unused case for now
                    //if (binding['_ko_property_writers'] && binding['_ko_property_writers']['value']) {
                    //    binding['_ko_property_writers']['value'](valueToWrite);
                    //    //Because this is not an observable, we have to manually change the controls values
                    //    // since update will not do it for us (it will not fire since it is not observable)
                    //    displayElement.val(labelToWrite);
                    //    $(element).val(valueToWrite);
                    //}
                }
            };

            handleValueChange = function (event, ui) {
                var labelToWrite = ui.item ? ui.item.label : null
                var valueToWrite = ui.item ? ui.item.value : null;

                var changedValue = null;

                if (labelToWrite && valueToWrite) {
                    if (ko.isWriteableObservable(modelSelectedItem)) {
                        var selectedItem = ko.bindingHandlers.autoComplete.findSelectedItem(dataSource, binding, valueToWrite);
                        writeValueToModel(selectedItem);
                        changedValue = selectedItem;
                    }
                } else {
                    //They did not make a valid selection so make sure that it is a valid value or clear out the model value
                    var autocompleteValue = $(event.target).val();
                    var matchingItem = ko.bindingHandlers.autoComplete.findAutocompleteItem(dataSource, binding, autocompleteValue);

                    if (matchingItem) {
                        writeValueToModel(matchingItem);
                        var displayText = labelProp ? unwrap(matchingItem[labelProp]) : unwrap(matchingItem).toString();
                        displayElement.val(displayText);
                    } else {
                        //writeValueToModel(null);
                    }
                    changedValue = matchingItem;
                }   
                
                if (binding.autoCompleteValueChange) {
                    //labelToWrite = unwrap(matchingItem[labelProp]);
                    if (typeof binding.autoCompleteValueChange == "function") {
                        binding.autoCompleteValueChange(changedValue, labelToWrite);
                    }
                }

                handleValueChange_postprocessing();

                return false;
            };

        }

        var handleFocus = function (event, ui) {
            $(displayElement).val(ui.item.label);
            return false;
        };

        if (handleValueChange) {
            options.change = handleValueChange;
            options.select = handleValueChange;
        }
        options.focus = handleFocus;
        //options.close = handleValueChange;
        options.renderMenu = function (ul, items) {
            //var cls = '';
            //if (displayMenu.class && displayMenu.class != '') {
            //    $(ul).addClass(displayMenu.class);
            //}
            //$(ul).removeClass('ui-corner-all');

            if (autoCompleteQtip != '') {
                var $qtipContainer = $(element).closest(".qtip");
                if ($qtipContainer.length > 0) {
                    //var qtipId = $qtipContainer.data('qtip-id');
                    //var $qtip = null;
                    //var g = $.grep($(autoCompleteQtip), function (item) {
                    //    var $item = $(item);
                    //    return $item.data('hasqtip') == qtipId;
                    //});
                    //if (g && g.length > 0) {
                    //    $qtip = $(g[0]);
                    //}
                    //
                    //if ($qtip && $qtip.length > 0) {
                    //    var qtip = $qtip.qtip('api');
                    //    if (qtip) {
                    //        qtip.hide();
                    //        ScrollToSearchBarForDropDown($qtip);
                    //    }
                    //}
                    var isModalMode = $qtipContainer.hasClass("modal");
                    if (isModalMode) {
                        $(ul).addClass("modal");
                    } else {
                        $(ul).removeClass("modal");
                    }
                }
            }


        };
        //options.open = function (event, ui) {
        //    console.log(event);
        //};
        

        if (!binding.autoCompleteSource && typeof binding.autoCompleteSource != "function") {
            //handle the choices being updated in a Dependant Observable (DO), so the update function doesn't 
            // have to do it each time the value is updated. Since we are passing the dataSource in DO, if it is
            // an observable, when you change the dataSource, the dependentObservable will be re-evaluated
            // and its subscribe event will fire allowing us to update the autocomplete datasource
            var mappedSource = ko.dependentObservable(function () {
                return ko.bindingHandlers.autoComplete.buildDataSource(dataSource, labelProp, valueProp);
            }, viewModel);
            //Subscribe to the knockout observable array to get new/remove items
            mappedSource.subscribe(function (newValue) {
                displayElement.autocomplete("option", "source", newValue);
            });

            options.source = mappedSource();
        } else {
            options.source = function (request, response) {
                let mappedResponse = function (items) {
                    dataSource = items;
                    response(ko.bindingHandlers.autoComplete.buildDataSource(dataSource, labelProp, valueProp));
                };

                binding.autoCompleteSource(request, mappedResponse);
            }
        }

        displayElement.autocomplete(options);

        let autocomplete = displayElement.data('ui-autocomplete');
        if (menuOptions && autocomplete && autocomplete.menu) {
            autocomplete.menu._setOptions(menuOptions);
            //console.log(autocomplete.menu);
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        //update value based on a model change
        var unwrap = ko.utils.unwrapObservable;
        var dataSource = valueAccessor();
        var binding = allBindingsAccessor();
        var valueProp = unwrap(binding.optionsValue);
        var labelProp = unwrap(binding.optionsText) || valueProp;
        var displayId = $(element).attr('id') + '-display';
        var displayElement = $('#' + displayId);
        var modelValue = binding.value;

        if (modelValue) {
            var currentModelValue = unwrap(modelValue);
            //Set the hidden box to be the same as the viewModels Bound property
            $(element).val(currentModelValue);
            //Go through the source and find the id, and use its label to set the autocomplete
            var selectedItem = ko.bindingHandlers.autoComplete.findSelectedItem(dataSource, binding, currentModelValue);
            if (selectedItem) {
                var displayText = labelProp ? unwrap(selectedItem[labelProp]) : unwrap(selectedItem).toString();
                //displayElement.val(displayText);
                var bindTo = unwrap(binding.autoCompleteSearchTerm) || "";
                if (bindTo != null && bindTo != "") {
                    displayElement.val('');
                } else {
                    displayElement.val(displayText);
                }
            } else {
                //displayElement.val('');
            }
        }
    }
};